module.exports = {
  theme: {
    primary: '#2CA874',
    secondary: '#234276',
    light: '#8898A0',
    medium: '#687982',
    dark: '#123241',
    white: '#FFFFFF',
    success: '#4BCA81',
    warning: '#FFB75D',
    error: '#F05A5B',
    info: '#00ADD0',
    'accent-1': '#209564',
    'accent-2': '#5863F8',
    'accent-3': '#FFCB47',
    'product-1': '#F16E24',
    'product-2': '#F05A5B',
    'product-3': '#2399EF',
    'primary-light': '#E6F7F1',
    'success-light': '#EDFAF2',
    'warning-light': '#FFF9E6',
    'error-light': '#FEEFEF',
    'info-light': '#E6F7FA',
    'green-0': '#E6F7F1',
    'green-100': '#00DD80',
    'green-200': '#00B074',
    'green-300': '#02A26B',
    'green-400': '#087C4F',
    'green-500': '#036644',
    'green-600': '#055939',
    'green-700': '#003E28',
    'grey-100': '#F8F8F8',
    'grey-200': '#F6F6F6',
    'grey-300': '#EBEBEB',
    'grey-400': '#E6E6E6',
    'grey-500': '#CCCCCC',
    'grey-600': '#C1C1C1',
    'grey-700': '#666666',
    'grey-800': '#222222'
  }
};
